// FIXME: refactor me to make more generic for reuse across different modules
import React, { useEffect } from 'react';
import ClayModal from '@clayui/modal';
import ClayCard from '@clayui/card';
import './FiltersModal.css';
import { useForm } from 'react-hook-form';
import FormComponent from '../formComponent/FormComponent';
import CustomButton from '../customButton/CustomButton';
import { FilterObject } from '../../utils/matchMaking.config';

interface modalProps {
    open: boolean;
    observer: any;
    getFilterBasedEventData: (filters?: FilterObject) => void;
    setFilters: React.Dispatch<React.SetStateAction<FilterObject>>;
    dropdownOptions: [];
    filterFields: any;
}

const FiltersModal: React.FC<modalProps> = ({
    open,
    observer,
    setFilters,
    getFilterBasedEventData,
    dropdownOptions,
    filterFields
}) => {
    const {
        control,
        register,
        watch,
        setError,
        reset,
        formState: { errors: formErrors }
    } = useForm();
    const selectedRequestStatus = watch('requestorStatus');
    const selectedRequestDate = watch('requestDate');

    useEffect(() => {
        if (selectedRequestStatus || selectedRequestDate)
            setFilters((prevData: FilterObject) => ({
                ...prevData,
                selectedRequestStatus: selectedRequestStatus,
                requestDate: selectedRequestDate
            }));
    }, [selectedRequestDate, selectedRequestDate]);

    const clearAllFilterData = async () => {
        const initFilters: FilterObject = {
            requestorStatus: [],
            requestDate: []
        };

        reset(initFilters); // Reset all form fields
        setFilters((prevData: FilterObject) => ({
            ...prevData,
            ...initFilters
        }));

        getFilterBasedEventData(initFilters);
    };

    return (
        <div className="partner-filter-container">
            {open && (
                <ClayModal
                    observer={observer}
                    className="filters-modal-container custom-modal-slide-right"
                >
                    <ClayModal.Header className="custom-filter-header">
                        Filters
                    </ClayModal.Header>
                    <ClayModal.Body>
                        <ClayCard className="date-picker-card custom-card mr-1 mb-3">
                            {filterFields.map((data: any) => {
                                return (
                                    <FormComponent
                                        placeholder={data.placeholder}
                                        label={data.label}
                                        name={data.name}
                                        register={register}
                                        type={data.type}
                                        control={control}
                                        errors={formErrors}
                                        watch={watch}
                                        setError={setError}
                                        errorTitle={data.errorMessage}
                                        options={dropdownOptions[data.name]}
                                        required={data.required}
                                        disabled={false}
                                    />
                                );
                            })}
                        </ClayCard>

                        <div className="filter-btn-container">
                            <CustomButton
                                label="Clear"
                                onClick={() => clearAllFilterData()}
                                type="button"
                            />
                            <CustomButton
                                label="Apply"
                                onClick={() => getFilterBasedEventData()}
                                type="button"
                            />
                        </div>
                    </ClayModal.Body>
                </ClayModal>
            )}
        </div>
    );
};

export default FiltersModal;
